import { Component, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SharedService } from 'src/app/shared/service/shared.service';

@Component({
  selector: 'app-factory-popup',
  templateUrl: './factory-popup.component.html',
  styleUrls: ['./factory-popup.component.scss']
})
export class FactoryPopupComponent implements OnInit {
  clusterList: any[] = [];
  factoryList: any[] = [];
  selectedCluster: any;
  selectedFactory: any;
  filteredData: any = {
    cluster: {
      list: [],
      searchText: ''
    },
    factory: {
      list: [],
      searchText: ''
    }
  };
  factoryDisabled: boolean;
  disableSubmit: boolean;
  uniqueClusterList: any;

  constructor(
    public dialogRef: MatDialogRef<FactoryPopupComponent>,
    private service: SharedService
  ) { }

  ngOnInit() {
    this.getCluster();
  }

  close_dialogue(btnClicked: any) {
    const data = {
      clickedBtn: btnClicked,
      selectedCluster: '',
      selectedFactory: ''
    };

    if (btnClicked === 'select') {
      sessionStorage.setItem('selectedDACluster', JSON.stringify(this.factoryList));
      data.selectedCluster = this.selectedCluster;
      data.selectedFactory = this.selectedFactory;
    }

    this.dialogRef.close(data);
  }
  /* istanbul ignore next */
  getCluster() {
    this.filteredData.cluster.searchText = null;
    this.filteredData.factory.searchText = null;
    this.filteredData.factory.list = [];
    this.factoryList = [];
    this.selectedFactory = null;

    this.factoryDisabled = true;
    this.disableSubmit = true;

    // this.service.getClusterList().subscribe(result => {
    const clusters = JSON.parse(sessionStorage.getItem('dfos.userfactory.data'));
    if (clusters) {
      this.clusterList = clusters;
      this.filteredData.cluster.list = this.clusterList;
      this.uniqueClusterList = [];
      this.uniqueClusterList = [...new Map(this.clusterList.map((m) => [m.name, m])).values()];
      this.uniqueClusterList.sort((a, b) => a.name.localeCompare(b.name));
      // let testList = this.filteredData.cluster.list;
      console.log('testlist', this.uniqueClusterList);

      if (this.clusterList && this.clusterList.length === 1) {
        this.selectedCluster = this.clusterList[0];
        this.filteredData.cluster.searchText = this.clusterList[0];
        this.getFactory();
      }
    }
    // });
  }
  /* istanbul ignore next */
  getFactory() {
    this.factoryList = this.filteredData.factory.list = [];
    for (let index = 0; index < this.clusterList.length; index++) {
      if (this.clusterList[index].name === this.selectedCluster.name) {
        this.clusterList.forEach((entry) => {
          entry.factoryList.forEach(element => {
            element['id'] = entry.id;
            element['subRegionName'] = entry.name;
          });

          // console.log(entry);
        });

        this.filteredData.factory.list = this.factoryList = [...this.factoryList, ...this.clusterList[index].factoryList];
        // this.fileredClusterList.concat(testList);

      }
      this.factoryList.sort((a, b) => a.name.localeCompare(b.name));

    }
    if (this.selectedCluster) {
      this.service.getTopFactoryList(this.selectedCluster).subscribe(result => {
        // this.factoryList = result;
        this.filteredData.factory.list = this.factoryList;
        this.factoryDisabled = false;

        if (this.factoryList && this.factoryList.length === 1) {
          this.selectedFactory = this.factoryList[0];
          this.filteredData.factory.searchText = this.factoryList[0];
        }
      });
    }
  }

  clusterValueMapper = (selectedObj) => {
    if (selectedObj) {
      const selection = this.clusterList.find(e => {
        return e.name === selectedObj.name;
      });
      if (selection) {
        this.selectedCluster = selection;
        this.getFactory();
        return selection.name;
      }
    }
  }

  factoryValueMapper = (selectedObj) => {
    if (selectedObj) {
      const selection = this.factoryList.find(e => {
        return e.factoryId === selectedObj.factoryId;
      });
      if (selection) {
        this.selectedFactory = selection;
        this.disableSubmit = false;
        return selection.name;
      }
    }
  }

  /* istanbul ignore next */
  autoComplete(event: string, changedFilter: string) {
    const evt = event + '';

    switch (changedFilter) {
      case 'cluster':
        this.filteredData.factory.searchText = null;
        //        this.filteredData.factory.list = [];
        //        this.factoryList = [];
        this.selectedFactory = null;

        this.factoryDisabled = true;
        this.disableSubmit = true;

        if (evt) {
          this.uniqueClusterList = [...new Map(this.clusterList.map((m) => [m.name, m])).values()];
          this.uniqueClusterList = this.uniqueClusterList.filter
            (item => (item.id + '') === evt || item.name.toLocaleLowerCase().indexOf(evt.toLocaleLowerCase()) >= 0);
        } else {
          this.uniqueClusterList = [...new Map(this.clusterList.map((m) => [m.name, m])).values()];
          this.uniqueClusterList.sort((a, b) => a.name.localeCompare(b.name));
        }
        break;

      case 'factory':
        if (evt) {
          const clonedFactoryList = [...this.factoryList];
          this.filteredData.factory.list = clonedFactoryList.filter
            (item => (item.name + '') === evt || item.name.toLocaleLowerCase().indexOf(evt.toLocaleLowerCase()) >= 0);
        } else {
          this.uniqueClusterList = [...new Map(this.clusterList.map((m) => [m.name, m])).values()];
          this.uniqueClusterList.sort((a, b) => a.name.localeCompare(b.name));
          this.filteredData.factory.list = this.factoryList;
          this.filteredData.factory.list.sort((a, b) => a.name.localeCompare(b.name));
        }
        break;
    }

    if (this.filteredData.factory.list.length >= 1) {
      this.selectedFactory = null;
      this.disableSubmit = true;
    }
  }

}
